import axios from "../../../util/axios";

export default {
    /** 查询列表 */
    queryList: (data) => axios.get({url: "/basedata/system/version/queryList", data: data}),
    /** 保存 */
    save: (data) => axios.post({url: "/basedata/system/version/save", data: data}),
    /** 删除 */
    delete: (id) => axios.del({url: "/basedata/system/version/queryList", data: {id}}),
}